import { MASTER_ADMIN_URL_PREFIX } from '@/const/shared';
import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getMasterAdminOrganizationUserDetailsPath = (userId: string = ':id') => {
  return urlHelper(`${MASTER_ADMIN_URL_PREFIX}/organization/user/${userId}/details`);
};
